<div class="investment-instruction-card" [style.border-color]="borderColor" [style.background-color]="backgroundColor">
  <div class="dot" [style.background-color]="instruction?.fund | investmentInstructionFundColour"></div>
  <span class="fund-name">{{ instruction?.fund?.name }}</span>
  <span class="fund-percentage">{{ instruction?.percentage | number : '1.2-2' }}%</span>
</div>
